module.exports = __webpack_public_path__ + "static/pic11-db9d02874074254a525d93b9a2d3fd92.jpeg";